class deleteContact {
    constructor(Alert, $http, $state, $stateParams, $translate) {

        this.key = 'delete-contact';
        this.title = 'Delete';
        this.level = 'archived-highlight';
        this.icon = 'fal fa-trash-alt';
        this.alert = Alert;
        this.api = $http;
        this.state = $state;
        this.back = $stateParams.back;
        this.params = $stateParams.backParams || {
            id: $stateParams.id
        };
        this.translate = $translate;
    }

    action(contact, vm) {

        const translatedValue = (path, params) => {
            return this.translate.instant(`contacts.workflows.ask-to-delete-contact.${path}`, params);
        };

        this.alert.animatedAlert(
            translatedValue('title'),
            translatedValue('content', {contact_name: contact.full_name}),
            'attention',
            {
                confirmButtonText: translatedValue('confirm'),
                cancelButtonText: translatedValue('cancel'),
                wait: true
            }).then(() => {
            return this.api.delete(`contacts/${ contact.id }`, {data: {force: true}})
                .then(() => {
                    return this.state.go(this.back, this.params);
                }, err => this.alert.handle(err));
        }, () => ({}))
    }

}

angular
    .module('festzelt-os.contacts')
    .factory('deleteContact', [
        'Alert',
        '$http',
        '$state',
        '$stateParams',
        '$translate',
        (Alert, $http, $state, $stateParams, $translate) => new deleteContact(Alert, $http, $state, $stateParams, $translate)
    ]);




// WEBPACK FOOTER //
// ./src/app/pages/contacts/workflows/detailed-view/delete-contact.js